/* eslint-disable max-len */
import { cn } from '../cn';

export const IconPlay = ({ className = '' }): JSX.Element => (
  <svg role='img' className = {cn('inline', className)} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_1389_25560)'>
      <path d='M7 4V20L20 12L7 4Z' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
    </g>
    <defs>
      <clipPath id='clip0_1389_25560'>
        <rect width='24' height='24' fill='currentColor'/>
      </clipPath>
    </defs>
  </svg>
);
